import Main from "../components/dashboard/Dashboard";

const Home = () =>
{
    return(
        <Main/>
    )

}

export default Home;
